<template>
  <article
    :class="{
      'pricing-tariffs-card': true,
      'pricing-tariffs-card--small': tariff === 'small',
      'pricing-tariffs-card--professional': tariff === 'professional',
      'pricing-tariffs-card--maximum': tariff === 'maximum',
      'pricing-tariffs-card--enterprise': tariff === 'enterprise',
      'pricing-tariffs-card--popular': tariff === 'maximum',
    }"
    :data-label="translations['tariffs'][tariff]['label']"
    itemprop="offers"
    itemscope
    itemtype="http://schema.org/AggregateOffer"
  >
    <div class="pricing-tariffs-card__inner">
      <header class="pricing-tariffs-card__header">
        <h2
          class="pricing-tariffs-card__title"
          :data-label="translations['label']"
          v-html="translations['tariffs'][tariff]['title']"
        />
        <div
          class="pricing-tariffs-card__description"
          itemprop="description"
          v-html="translations['tariffs'][tariff]['description']"
        />
      </header>
      <div class="pricing-tariffs-card__content">
        <meta itemprop="priceCurrency" :content="currency" />
        <p v-if="tariff === 'enterprise' && lang !== 'en'" class="pricing-tariffs-card__price">
          <label v-html="translations['price']['enterprise']" />
        </p>
        <p v-else-if="tariff !== 'enterprise'" class="pricing-tariffs-card__price">
          <price :tariff="tariff" :period="'month'" :currency="currency" itemprop="price"></price>
          <label v-html="translations['price']['label']" />
        </p>
        <a
          v-if="tariff === 'enterprise' && lang === 'en'"
          href="mailto:sales@huntflow.ai"
          :class="{
            'button button--sm': true,
            'button--inverted': tariff === 'enterprise',
          }"
          v-html="translations['price']['enterprise']"
        />
        <button
          v-else
          type="button"
          :class="{
            'button button--sm': true,
            'button--inverted': tariff === 'enterprise',
          }"
          data-modal="#demoRequestModal"
          :data-additional-form-params="`{ &quot;tariff_name&quot;: &quot;${translations['tariffs'][tariff]['title']}&quot; }`"
          v-html="translations['button']"
        />
      </div>
    </div>
    <div style="visibility: hidden" itemprop="brand" itemtype="https://schema.org/Brand" itemscope>
      <meta itemprop="name" content="Хантфлоу" />
    </div>
  </article>
</template>

<script>
import translations from './pricing-translations';
import Price from '../Price/Price.vue';

export default {
  name: 'PricingTariffsCard',
  components: { Price },
  props: {
    currency: {
      type: String,
      default: 'rub',
    },
    lang: {
      type: String,
      default: 'ru',
    },
    tariff: {
      type: String,
      required: true,
    },
  },
  computed: {
    translations() {
      return translations[this.lang];
    },
  },
};
</script>
